import { APPROVAL_FLOW_TYPE } from '../constants/campaignBuilder.js';
import type { CampaignType } from '../types/_campaigns/campaigns.js';
import { BuyingPlanInfo } from '../types/buyingPlanInfo.js';

export const prepareApprovalStatusBarProps = ({
  campaign,
  selectedPlan,
}: {
  campaign: CampaignType;
  selectedPlan: BuyingPlanInfo;
}) => {
  const { id: campaignId, name: campaignName } = campaign;
  const { id, name, dateFrom, dateTo, campaignBudget, budget, totals } =
    selectedPlan;

  return {
    objectId: String(id),
    type: APPROVAL_FLOW_TYPE,
    obj: {
      campaignId: String(campaignId),
      campaignName,
      objectName: name,
      dateFrom,
      dateTo,
      campaignBudget: Number(campaignBudget),
      plannedBudget: Number(budget),
      netMediaBudget: Number(totals.budget),
    },
  };
};
